<button
  [type]="type"
  [disabled]="disabled"
  [ngClass]="classes"
  (click)="onClick($event)"
>
  <ng-content></ng-content>
</button>
